import { render, staticRenderFns } from "./h2Title.vue?vue&type=template&id=ea71cd40&scoped=true&"
import script from "./h2Title.vue?vue&type=script&lang=js&"
export * from "./h2Title.vue?vue&type=script&lang=js&"
import style0 from "./h2Title.vue?vue&type=style&index=0&id=ea71cd40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea71cd40",
  null
  
)

export default component.exports